import { UStyles } from "@/app/utils/UStyles";
import styles from "./ProspectSources.module.css";

type Props = {
  label: string;
  value: number;
  onClick?: () => void;
};

export default function ProspectSourceStat(props: Props) {
  const { label, value, onClick } = props;

  if (onClick) {
    return (
      <button
        type="button"
        className={UStyles.classNames(styles.statCell, styles.statClickable)}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <span className={styles.statValue}>{value}</span>
        <span className={styles.statLabel}>{label}</span>
        <span className={styles.statArrow} aria-hidden={true}>
          &rarr;
        </span>
      </button>
    );
  }

  return (
    <div className={styles.statCell}>
      <span className={styles.statValue}>{value}</span>
      <span className={styles.statLabel}>{label}</span>
    </div>
  );
}
